import ShipmentsList from "../../components/shipment/ShipmentsList";

export default function Shipments() {
  return <ShipmentsList />;
}
